import { render, staticRenderFns } from "./OurOffers.vue?vue&type=template&id=52676650&"
import script from "./OurOffers.vue?vue&type=script&lang=js&"
export * from "./OurOffers.vue?vue&type=script&lang=js&"
import style0 from "./OurOffers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports